export default function ContactSection() {
  return (
    <section id="contacto" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
            <i className="ri-customer-service-line text-3xl text-amber-600"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Contáctanos</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Estamos aquí para ayudarte. Comunícate con nosotros por cualquiera de nuestros canales
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-8 text-center hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-amber-200">
            <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-phone-fill text-3xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Teléfono</h3>
            <p className="text-gray-600 mb-2">(601) 7942180</p>
            <p className="text-sm text-gray-500">Lunes a Viernes: 8:00 a.m. - 6:00 p.m.</p>
            <p className="text-sm text-gray-500">Sábados: 8:00 a.m. - 3:00 p.m.</p>
          </div>

          <div className="bg-white p-8 text-center hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-amber-200">
            <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-whatsapp-fill text-3xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">WhatsApp</h3>
            <p className="text-gray-600 mb-4">+57 318 336 5407</p>
            <a
              href="https://wa.me/573183365407"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-600 text-white px-6 py-2 hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Chatear Ahora
            </a>
          </div>

          <div className="bg-white p-8 text-center hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-amber-200">
            <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-fill text-3xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Email</h3>
            <p className="text-gray-600 break-all">Cobranzas@cash24-7.co</p>
            <p className="text-sm text-gray-500 mt-2">Respuesta en 24-48 horas</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-gray-700 to-gray-800 p-12 text-white hover:shadow-2xl transition-all duration-300">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-hand-coin-line text-4xl"></i>
              </div>
              <h3 className="text-3xl font-bold">NEGOCIAR DEUDA</h3>
            </div>
            <p className="text-lg mb-8 text-white/90">
              ¿Tienes dificultades para pagar? Hablemos y encontremos la mejor solución para ti. 
              Ofrecemos planes de pago flexibles adaptados a tu situación.
            </p>
            <a
              href="https://wa.me/573183365407?text=Hola,%20necesito%20negociar%20mi%20deuda"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-gray-800 px-8 py-4 text-lg font-bold hover:bg-gray-100 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Negociar por WhatsApp
            </a>
          </div>

          <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-12 text-white hover:shadow-2xl transition-all duration-300">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-amber-400/20 backdrop-blur-sm rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-2-line text-4xl text-amber-400"></i>
              </div>
              <h3 className="text-3xl font-bold">CONTACTAR AGENTE</h3>
            </div>
            <p className="text-lg mb-8 text-gray-300">
              ¿Necesitas hablar con un asesor? Nuestro equipo está listo para atenderte y 
              resolver todas tus dudas de manera personalizada.
            </p>
            <a
              href="https://wa.me/573183365407?text=Hola,%20necesito%20hablar%20con%20un%20asesor"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gray-700 text-white px-8 py-4 text-lg font-bold hover:bg-gray-600 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
